import React from "react";
import styled from "styled-components";

interface Props {
	width?: number;
	margin?: string;
}

const Divider: React.FC<Props> = (props) => {
	return <DividerStyles {...props} />;
};

export default Divider;

const DividerStyles = styled.div<Props>`
	margin: ${(props) => props.margin || "0.9rem 0"};
	border-bottom: ${(props) =>
		`${props.width || 2}px solid ${props.theme.colors.COLOR_DIVIDER_GRAY}`};
`;
